import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SalesHome from './SalesHome';
import {
  SALES_SESSION_PATH,
  DEPOSIT_PATH,
  NEW_SALES_SESSION_PATH,
  EXPENSE_PATH,
  NEW_EXPENSE_PATH,
  PRICING_PROFILE_PATH,
  SALES_UNIT_PATH,
  NEW_PRICING_PROFILE_PATH,
  LIQUIDATION_SESSION_PATH,
  NEW_LIQUIDATION_SESSION_PATH,
  NEW_DEPOSIT_PATH,
  GENERAL_INCOME_PATH,
  NEW_GENERAL_INCOME_PATH,
  DISCOUNT_TO_BENEFICIARIES_PATH,
  EXPENSE_STATUS_PATH,
  generateExpenseStatusAddRemarkPath,
  CREDIT_NOTE_PATH,
  NEW_CREDIT_NOTE_PATH,
  DISCOUNT_CODE_PATH,
  NEW_DISCOUNT_CODE_PATH,
  DISCOUNT_CODE_CATEGORY_PATH,
  NEW_DISCOUNT_CODE_CATEGORY_PATH,
  DISCOUNT_CODE_AUTHORIZER_PATH,
  NEW_DISCOUNT_CODE_AUTHORIZER_PATH,
  PRICING_PROFILE_DATE_RANGE_PATH,
  NEW_PRICING_PROFILE_DATE_RANGE_PATH,
  CLONE_PRICING_PROFILE_DATE_RANGE_PATH,
  PRICING_PROFILE_MASSIVE_UPDATE_PATH,
  NEW_PRICING_PROFILE_MASSIVE_UPDATE_PATH,
  FREE_OF_CHARGE_CATEGORY_PATH,
  NEW_FREE_OF_CHARGE_CATEGORY_PATH,
  FREE_OF_CHARGE_RULE_PATH,
  NEW_FREE_OF_CHARGE_RULE_PATH,
  BANK_RECONCILIATION_PATH,
  DEPOSIT_MIGRATION_PATH,
  NEW_DEPOSIT_MIGRATION_PATH,
} from '../../../config/paths';
import SalesSessions from './salesSession/SalesSessions';
import SalesSession from './salesSession/SalesSession';
import NewSalesSession from './salesSession/NewSalesSession';
import Expenses from './expense/Expenses';
import Expense from './expense/Expense';
import NewExpense from './expense/NewExpense';
import EditExpense from './expense/EditExpense';
import PricingProfiles from './princing-profile/PricingProfiles';
import NewPricingProfile from './princing-profile/NewPricingProfile';
import PricingProfile from './princing-profile/PricingProfile';
import EditPricingProfile from './princing-profile/EditPricingProfile';
import LiquidationSessions from './liquidation-session/LiquidationSessions';
import LiquidationSession from './liquidation-session/LiquidationSession';
import NewLiquidationSession from './liquidation-session/NewLiquidationSession';
import EditLiquidationSession from './liquidation-session/EditLiquidationSession';
import Deposits from './deposit/Deposits';
import NewDeposit from './deposit/NewDeposit';
import Deposit from './deposit/Deposit';
import EditDeposit from './deposit/EditDeposit';
import GeneralIncomes from './general-income/GeneralIncomes';
import NewGeneralIncome from './general-income/NewGeneralIncome';
import GeneralIncome from './general-income/GeneralIncome';
import EditGeneralIncome from './general-income/EditGeneralIncome';
import DiscountToBeneficiary from './discount-to-beneficiary/DiscountToBeneficiary';
import ExpensesPerUser from './expense-status/ExpensesPerUser';
import ExpensePerUser from './expense-status/ExpensePerUser';
import ExpenseStatusAddRemarkForm from './expense-status/ExpenseStatusAddRemarkForm';
import CreditNotes from './credit-note/CreditNotes';
import NewCreditNote from './credit-note/NewCreditNote';
import CreditNote from './credit-note/CreditNote';
import EditCreditNote from './credit-note/EditCreditNote';
import DiscountCodes from './discount-code/DiscountCodes';
import DiscountCode from './discount-code/DiscountCode';
import NewDiscountCode from './discount-code/NewDiscountCode';
import EditDiscountCode from './discount-code/EditDiscountCode';
import DiscountCodeCategories from './discount-code-category/DiscountCodeCategories';
import DiscountCodeCategory from './discount-code-category/DiscountCodeCategory';
import NewDiscountCodeCategory from './discount-code-category/NewDiscountCodeCategory';
import EditDiscountCodeCategory from './discount-code-category/EditDiscountCodeCategory';
import DiscountCodeAuthorizers from './discount-code-authorizer/DiscountCodeAuthorizers';
import DiscountCodeAuthorizer from './discount-code-authorizer/DiscountCodeAuthorizer';
import NewDiscountCodeAuthorizer from './discount-code-authorizer/NewDiscountCodeAuthorizer';
import EditDiscountCodeAuthorizer from './discount-code-authorizer/EditDiscountCodeAuthorizer';
import PricingProfileDateRanges from './pricing-profile-date-range/PricingProfileDateRanges';
import NewPricingProfileDateRange from './pricing-profile-date-range/NewPricingProfileDateRange';
import PricingProfileDateRange from './pricing-profile-date-range/PricingProfileDateRange';
import EditPricingProfileDateRange from './pricing-profile-date-range/EditPricingProfileDateRange';
import ClonePricingProfileDateRange from './pricing-profile-date-range/ClonePricingProfileDateRange';
import PricingProfileMassiveUpdates from './pricing-profile-massive-update/PricingProfileMassiveUpdates';
import NewPricingProfileMassiveUpdate from './pricing-profile-massive-update/NewPricingProfileMassiveUpdate';
import PricingProfileMassiveUpdate from './pricing-profile-massive-update/PricingProfileMassiveUpdate';
import FreeOfChargeCategories from './free-of-charge-category/FreeOfChargeCategories';
import NewFreeOfChargeCategory from './free-of-charge-category/NewFreeOfChargeCategory';
import FreeOfChargeCategory from './free-of-charge-category/FreeOfChargeCategory';
import EditFreeOfChargeCategory from './free-of-charge-category/EditFreeOfChargeCategory';
import FreeOfChargeRules from './free-of-charge-rule/FreeOfChargeRules';
import NewFreeOfChargeRule from './free-of-charge-rule/NewFreeOfChargeRule';
import FreeOfChargeRule from './free-of-charge-rule/FreeOfChargeRule';
import BankReconciliation from './bank-reconciliation/BankReconciliation';
import DepositMigrations from './deposit-migration/DepositMigrations';
import NewDepositMigration from './deposit-migration/NewDepositMigration';
import DepositMigration from './deposit-migration/DepositMigration';

const SalesUnit = () => (
  <Switch>
    <Route exact path={SALES_UNIT_PATH} component={SalesHome} />
    <Route exact path={PRICING_PROFILE_PATH} component={PricingProfiles} />
    <Route
      exact
      path={NEW_PRICING_PROFILE_PATH}
      component={NewPricingProfile}
    />
    <Route
      exact
      path={`${PRICING_PROFILE_PATH}/:id`}
      component={PricingProfile}
    />
    <Route
      exact
      path={`${PRICING_PROFILE_PATH}/:id/edit`}
      component={EditPricingProfile}
    />
    <Route exact path={SALES_SESSION_PATH} component={SalesSessions} />
    <Route
      exact
      path={`${NEW_SALES_SESSION_PATH}`}
      component={NewSalesSession}
    />
    <Route exact path={`${SALES_SESSION_PATH}/:id`} component={SalesSession} />
    <Route exact path={EXPENSE_PATH} component={Expenses} />
    <Route exact path={`${NEW_EXPENSE_PATH}`} component={NewExpense} />
    <Route exact path={`${EXPENSE_PATH}/:id`} component={Expense} />
    <Route exact path={`${EXPENSE_PATH}/:id/edit`} component={EditExpense} />
    <Route
      exact
      path={LIQUIDATION_SESSION_PATH}
      component={LiquidationSessions}
    />
    <Route
      exact
      path={NEW_LIQUIDATION_SESSION_PATH}
      component={NewLiquidationSession}
    />
    <Route
      exact
      path={`${LIQUIDATION_SESSION_PATH}/:id`}
      component={LiquidationSession}
    />
    <Route
      exact
      path={`${LIQUIDATION_SESSION_PATH}/:id/edit`}
      component={EditLiquidationSession}
    />
    <Route exact path={DEPOSIT_PATH} component={Deposits} />
    <Route exact path={NEW_DEPOSIT_PATH} component={NewDeposit} />
    <Route exact path={`${DEPOSIT_PATH}/:id`} component={Deposit} />
    <Route exact path={`${DEPOSIT_PATH}/:id/edit`} component={EditDeposit} />
    <Route exact path={GENERAL_INCOME_PATH} component={GeneralIncomes} />
    <Route exact path={NEW_GENERAL_INCOME_PATH} component={NewGeneralIncome} />
    <Route
      exact
      path={`${GENERAL_INCOME_PATH}/:id`}
      component={GeneralIncome}
    />
    <Route
      exact
      path={`${GENERAL_INCOME_PATH}/:id/edit`}
      component={EditGeneralIncome}
    />
    <Route
      exact
      path={DISCOUNT_TO_BENEFICIARIES_PATH}
      component={DiscountToBeneficiary}
    />
    <Route exact path={EXPENSE_STATUS_PATH} component={ExpensesPerUser} />
    <Route
      exact
      path={`${EXPENSE_STATUS_PATH}/:id`}
      component={ExpensePerUser}
    />
    <Route
      exact
      path={generateExpenseStatusAddRemarkPath()}
      component={ExpenseStatusAddRemarkForm}
    />
    <Route exact path={CREDIT_NOTE_PATH} component={CreditNotes} />
    <Route exact path={NEW_CREDIT_NOTE_PATH} component={NewCreditNote} />
    <Route exact path={`${CREDIT_NOTE_PATH}/:id`} component={CreditNote} />
    <Route
      exact
      path={`${CREDIT_NOTE_PATH}/:id/edit`}
      component={EditCreditNote}
    />
    <Route exact path={DISCOUNT_CODE_PATH} component={DiscountCodes} />
    <Route exact path={NEW_DISCOUNT_CODE_PATH} component={NewDiscountCode} />
    <Route exact path={`${DISCOUNT_CODE_PATH}/:id`} component={DiscountCode} />
    <Route
      exact
      path={`${DISCOUNT_CODE_PATH}/:id/edit`}
      component={EditDiscountCode}
    />
    <Route
      exact
      path={DISCOUNT_CODE_CATEGORY_PATH}
      component={DiscountCodeCategories}
    />
    <Route
      exact
      path={NEW_DISCOUNT_CODE_CATEGORY_PATH}
      component={NewDiscountCodeCategory}
    />

    <Route
      exact
      path={`${DISCOUNT_CODE_CATEGORY_PATH}/:id`}
      component={DiscountCodeCategory}
    />
    <Route
      exact
      path={`${DISCOUNT_CODE_CATEGORY_PATH}/:id/edit`}
      component={EditDiscountCodeCategory}
    />
    <Route
      exact
      path={DISCOUNT_CODE_AUTHORIZER_PATH}
      component={DiscountCodeAuthorizers}
    />
    <Route
      exact
      path={NEW_DISCOUNT_CODE_AUTHORIZER_PATH}
      component={NewDiscountCodeAuthorizer}
    />
    <Route
      exact
      path={`${DISCOUNT_CODE_AUTHORIZER_PATH}/:id`}
      component={DiscountCodeAuthorizer}
    />
    <Route
      exact
      path={`${DISCOUNT_CODE_AUTHORIZER_PATH}/:id/edit`}
      component={EditDiscountCodeAuthorizer}
    />
    <Route
      exact
      path={PRICING_PROFILE_DATE_RANGE_PATH}
      component={PricingProfileDateRanges}
    />
    <Route
      exact
      path={NEW_PRICING_PROFILE_DATE_RANGE_PATH}
      component={NewPricingProfileDateRange}
    />
    <Route
      exact
      path={CLONE_PRICING_PROFILE_DATE_RANGE_PATH}
      component={ClonePricingProfileDateRange}
    />
    <Route
      exact
      path={`${PRICING_PROFILE_DATE_RANGE_PATH}/:id`}
      component={PricingProfileDateRange}
    />
    <Route
      exact
      path={`${PRICING_PROFILE_DATE_RANGE_PATH}/:id/edit`}
      component={EditPricingProfileDateRange}
    />
    <Route
      exact
      path={PRICING_PROFILE_MASSIVE_UPDATE_PATH}
      component={PricingProfileMassiveUpdates}
    />
    <Route
      exact
      path={NEW_PRICING_PROFILE_MASSIVE_UPDATE_PATH}
      component={NewPricingProfileMassiveUpdate}
    />
    <Route
      exact
      path={`${PRICING_PROFILE_MASSIVE_UPDATE_PATH}/:id`}
      component={PricingProfileMassiveUpdate}
    />
    <Route
      exact
      path={FREE_OF_CHARGE_CATEGORY_PATH}
      component={FreeOfChargeCategories}
    />
    <Route
      exact
      path={NEW_FREE_OF_CHARGE_CATEGORY_PATH}
      component={NewFreeOfChargeCategory}
    />
    <Route
      exact
      path={`${FREE_OF_CHARGE_CATEGORY_PATH}/:id`}
      component={FreeOfChargeCategory}
    />
    <Route
      exact
      path={`${FREE_OF_CHARGE_CATEGORY_PATH}/:id/edit`}
      component={EditFreeOfChargeCategory}
    />
    <Route
      exact
      path={FREE_OF_CHARGE_RULE_PATH}
      component={FreeOfChargeRules}
    />
    <Route
      exact
      path={NEW_FREE_OF_CHARGE_RULE_PATH}
      component={NewFreeOfChargeRule}
    />
    <Route
      exact
      path={`${FREE_OF_CHARGE_RULE_PATH}/:id`}
      component={FreeOfChargeRule}
    />
    <Route
      exact
      path={BANK_RECONCILIATION_PATH}
      component={BankReconciliation}
    />
    <Route
      exact
      path={DEPOSIT_MIGRATION_PATH}
      component={DepositMigrations}
    />
    <Route
      exact
      path={NEW_DEPOSIT_MIGRATION_PATH}
      component={NewDepositMigration}
    />
    <Route
      exact
      path={`${DEPOSIT_MIGRATION_PATH}/:id`}
      component={DepositMigration}
    />
  </Switch>
);

export default SalesUnit;
